import React from "react";
import PropTypes from "prop-types";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import EntityProxy from "data/util/EntityProxy";
import { Formform } from "./Form/form";
import { Layoutcolumn } from "./Layout/column";
import { Layoutcolumnset } from "./Layout/columnset";
import { Layoutgrid } from "./Layout/grid";
import { Layoutgridcell } from "./Layout/gridcell";
import { Layoutgridrow } from "./Layout/gridrow";
import { Layoutsection } from "./Layout/section";
import { NotFound } from "./NotFound";
import { StringFielddropdown } from "./StringField/dropdown";
import { StringFieldlabel } from "./StringField/label";
import { StringFieldtext } from "./StringField/text";
import { StringFieldtextarea } from "./StringField/textarea";
import { IntegerFieldlabel } from "./IntegerField/label";
import { IntegerFieldspinner } from "./IntegerField/spinner";
import { DateTimeFieldcalendar } from "./DateTimeField/calendar";
import { DateTimeFieldlabel } from "./DateTimeField/label";
import { DateFieldcalendar } from "./DateField/calendar";
import { DateFieldlabel } from "./DateField/label";
import { DecimalFieldlabel } from "./DecimalField/label";
import { DecimalFieldtext } from "./DecimalField/text";
import { FileFieldlabel } from "./FileField/label";
import { FileFieldmanager } from "./FileField/manager";
import { FileFieldrfpi } from "./FileField/rfpi";
import { TimeFieldlabel } from "./TimeField/label";
import { TimeFieldspinner } from "./TimeField/spinner";
import { Widgetbutton } from "./Widget/button";
import { Widgetlabel } from "./Widget/label";
import Widgettimestamp from "./Widget/timestamp";
import { Widgetvaluemutationbutton } from "./Widget/valuemutationbutton";
import { Widgetmagicrootsummarysection } from "./Widget/magicrootsummarysection";
import { CompositionFieldsummarysection } from "./CompositionField/summarysection";
import { CompositionFielddevicelesiongrid } from "./CompositionField/devicelesiongrid";
import { AssociationFieldrecordbrowser } from "./AssociationField/recordbrowser";
import { AssociationFieldlabel } from "./AssociationField/label";
import { AssociationFieldtypeahead } from "./AssociationField/typeahead";
import { ChoiceFieldtypeahead } from "./ChoiceField/typeahead";
import { ChoiceFieldcheckbox } from "./ChoiceField/checkbox";
import { ChoiceFielddropdown } from "./ChoiceField/dropdown";
import { AssociationFielddevicelesiongrid } from "./AssociationField/devicelesiongrid";
import { ChoiceFieldlabel } from "./ChoiceField/label";

export const resolver = descriptor => {
    switch (descriptor.type + descriptor.control) {
        // This IntelliJ token is enabled in the preferences at
        //     Editor > Code Style > Formatter Controls
        // @formatter:off
        case "AssociationFielddevicelesiongrid": return AssociationFielddevicelesiongrid;
        case "AssociationFieldlabel": return AssociationFieldlabel;
        case "AssociationFieldrecordbrowser": return AssociationFieldrecordbrowser;
        case "AssociationFieldtypeahead": return AssociationFieldtypeahead;
        case "ChoiceFieldcheckbox": return ChoiceFieldcheckbox;
        case "ChoiceFielddropdown": return ChoiceFielddropdown;
        case "ChoiceFieldlabel": return ChoiceFieldlabel;
        case "ChoiceFieldtypeahead": return ChoiceFieldtypeahead;
        case "CompositionFieldsummarysection": return CompositionFieldsummarysection;
        case "CompositionFielddevicelesiongrid": return CompositionFielddevicelesiongrid;
        case "DateFieldcalendar": return DateFieldcalendar;
        case "DateFieldlabel": return DateFieldlabel;
        case "DateTimeFieldcalendar": return DateTimeFieldcalendar;
        case "DateTimeFieldlabel": return DateTimeFieldlabel;
        case "DecimalFieldlabel": return DecimalFieldlabel;
        case "DecimalFieldtext": return DecimalFieldtext;
        case "FileFieldlabel": return FileFieldlabel;
        case "FileFieldmanager": return FileFieldmanager;
        case "FileFieldrfpi": return FileFieldrfpi;
        case "Formform": return Formform;
        case "IntegerFieldlabel": return IntegerFieldlabel;
        case "IntegerFieldspinner": return IntegerFieldspinner;
        case "Layoutcolumn": return Layoutcolumn;
        case "Layoutcolumnset": return Layoutcolumnset;
        case "Layoutgrid": return Layoutgrid;
        case "Layoutgridrow": return Layoutgridrow;
        case "Layoutgridcell": return Layoutgridcell;
        case "Layoutsection": return Layoutsection;
        case "StringFielddropdown": return StringFielddropdown;
        case "StringFieldlabel": return StringFieldlabel;
        case "StringFieldtext": return StringFieldtext;
        case "StringFieldtextarea": return StringFieldtextarea;
        case "TimeFieldlabel": return TimeFieldlabel;
        case "TimeFieldspinner": return TimeFieldspinner;
        case "Widgetbutton": return Widgetbutton;
        case "Widgetlabel": return Widgetlabel;
        case "Widgettimestamp": return Widgettimestamp;
        case "Widgetvaluemutationbutton": return Widgetvaluemutationbutton;
        case "Widgetmagicrootsummarysection": return Widgetmagicrootsummarysection;
        default: return NotFound;
        // @formatter:on
    }
};

export const renderer = (props) => {
    const {descriptor} = props;
    const Component = resolver(descriptor);
    if (Component == null) {
        return React.createElement(NotFound, {
            key: descriptor.key,
            descriptor,
        });
    }
    return React.createElement(Component, {
        ...props,
        key: descriptor.key,
    });
};

renderer.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes(null, false, true)),
    fluxContext: PropTypes.string.isRequired,
    activeRecord: PropTypes.instanceOf(EntityProxy).isRequired,
    onFocus: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    onKeyDown: PropTypes.func.isRequired,
    onGlobalRecordLookup: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/resolver.js